"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = SideBar;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _reactRouterDom = require("react-router-dom");

var _firebase = require("../firebase");

var _database = require("react-firebase-hooks/database");

var _useLocalStorage3 = require("../lib/useLocalStorage");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _templateObject14() {
  var data = _taggedTemplateLiteral(["\n  color: ", ";\n  text-transform: uppercase;\n  text-decoration: none;\n  font-size: 12px;\n  font-weight: 700;\n  font-family: GothamPro, Arial, sans-serif;\n  white-space: nowrap;\n\n  &:hover {\n    color: ", ";\n    text-decoration: underline;\n  }\n"]);

  _templateObject14 = function _templateObject14() {
    return data;
  };

  return data;
}

function _templateObject13() {
  var data = _taggedTemplateLiteral(["\n  flex: auto;\n  padding: 0 10px 0 20px;\n  line-height: 1.4;\n  font-size: 12px;\n\n  @media (min-width: 1400px) {\n    font-size: 14px;\n  }\n"]);

  _templateObject13 = function _templateObject13() {
    return data;
  };

  return data;
}

function _templateObject12() {
  var data = _taggedTemplateLiteral(["\n  width: 65px;\n  height: 34px;\n  background-image: url(/img/discord-icon.png);\n  background-size: contain;\n  background-repeat: no-repeat;\n}\n"]);

  _templateObject12 = function _templateObject12() {
    return data;
  };

  return data;
}

function _templateObject11() {
  var data = _taggedTemplateLiteral(["\n  background: #7289da;\n  padding: 10px 20px;\n  display: flex;\n  color: white;\n  position: absolute;\n  left: 0;\n  top: 0;\n  width: 100%;\n  z-index: 2;\n  align-items: center;\n"]);

  _templateObject11 = function _templateObject11() {
    return data;
  };

  return data;
}

function _templateObject10() {
  var data = _taggedTemplateLiteral(["\n  font-size: 12px;\n  color: #5f5f5f;\n  text-transform: uppercase;\n  border: none;\n  appearance: none;\n  background: none;\n  margin-left: 10px;\n"]);

  _templateObject10 = function _templateObject10() {
    return data;
  };

  return data;
}

function _templateObject9() {
  var data = _taggedTemplateLiteral(["\n  flex: auto;\n  font-size: 12px;\n  a {\n    color: white;\n    text-decoration: none;\n\n    &:hover {\n      color: whote;\n      text-decoration: underline;\n    }\n  }\n  @media (min-width: 1400px) {\n    font-size: 14px;\n  }\n"]);

  _templateObject9 = function _templateObject9() {
    return data;
  };

  return data;
}

function _templateObject8() {
  var data = _taggedTemplateLiteral(["\n  background: #151513;\n  padding: 20px;\n  display: flex;\n  color: white;\n  position: absolute;\n  left: 0;\n  bottom: -1px;\n  width: 100%;\n  z-index: 2;\n  align-items: center;\n"]);

  _templateObject8 = function _templateObject8() {
    return data;
  };

  return data;
}

function _templateObject7() {
  var data = _taggedTemplateLiteral(["\n  margin-bottom: ", ";\n\n  img {\n    height: ", ";\n  }\n"]);

  _templateObject7 = function _templateObject7() {
    return data;
  };

  return data;
}

function _templateObject6() {
  var data = _taggedTemplateLiteral(["\n  position: absolute;\n  left: 20px;\n  width: calc(100% - 40px);\n  top: 0;\n  height: 100%;\n"]);

  _templateObject6 = function _templateObject6() {
    return data;
  };

  return data;
}

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n  margin-top: 10px;\n\n  color: ", ";\n  font-size: 14px;\n  line-height: 1.5;\n\n  h2 {\n    color: #585858;\n    font-size: 18px;\n    margin: 0 0 15px 0;\n    font-weight: 400;\n  }\n\n  a {\n    color: white;\n\n    &:hover {\n      color: white;\n    }\n  }\n\n  ul {\n    margin-top: 10px;\n  }\n\n  li {\n    margin-bottom: 5px;\n    &:before {\n      content: '\u25CF';\n      display: inline-block;\n      margin-right: 10px;\n    }\n  }\n\n  p {\n    margin-top: 10px;\n  }\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n  position: relative;\n  flex: auto;\n  overflow: hidden;\n  min-height: 400px;\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n  padding: 10px 20px 20px;\n  color: #565656;\n\n  h2 {\n    font-size: 14px;\n    margin: 0;\n    font-weight: 400;\n  }\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n  margin: 0;\n  padding: 0;\n\n  li {\n    display: inline-block;\n    border-right: 3px solid #151513;\n\n    &:first-child {\n      border-left: 3px solid black;\n    }\n  }\n\n  a {\n    display: block;\n    border-bottom: 3px solid black;\n    padding: 15px 34px;\n    text-transform: uppercase;\n    text-decoration: none;\n    color: white;\n    background: black;\n    font-family: GothamPro, Arial, sans-serif;\n    font-size: 12px;\n    font-weight: 700;\n\n    &.selected,\n    &:hover {\n      text-decoration: none;\n      color: white;\n      background: #151513;\n      border-bottom-color: ", ";\n    }\n  }\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  flex: auto;\n  display: flex;\n  flex-direction: column;\n  background: black;\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var brandColor = '#fef502';

var Container = _styledComponents.default.div(_templateObject());

var Tabs = _styledComponents.default.div(_templateObject2(), brandColor);

var PartnerInfo = _styledComponents.default.div(_templateObject3());

var Chat = _styledComponents.default.div(_templateObject4());

var Description = _styledComponents.default.div(_templateObject5(), function (props) {
  return props.extended ? 'white' : '#5f5f5f';
});

var ChatIfrmae = _styledComponents.default.iframe(_templateObject6());

var ImageContainer = _styledComponents.default.div(_templateObject7(), function (props) {
  return props.bigger ? '20px' : '0px';
}, function (props) {
  return props.bigger ? '120px' : '80px';
});

var DiscordLoginOverlay = _styledComponents.default.div(_templateObject8());

var DiscordLoginOverlayText = _styledComponents.default.div(_templateObject9());

var DiscordLoginOverlayClose = _styledComponents.default.button(_templateObject10());

var DiscordOverlay = _styledComponents.default.div(_templateObject11());

var DiscordIcon = _styledComponents.default.div(_templateObject12());

var DiscordText = _styledComponents.default.div(_templateObject13());

var DiscordLink = _styledComponents.default.div(_templateObject14(), brandColor, brandColor);

function SideBar(_ref) {
  var partner = _ref.partner;
  var name = partner.name,
      description = partner.description,
      logo = partner.logo,
      showTabNav = partner.showTabNav,
      discordEmbedLink = partner.discordEmbedLink,
      chatDisabled = partner.chatDisabled,
      aboutLink = partner.aboutLink,
      descriptionExtended = partner.descriptionExtended,
      perks = partner.perks;

  var _useRouteMatch = (0, _reactRouterDom.useRouteMatch)(),
      path = _useRouteMatch.path,
      url = _useRouteMatch.url;

  var _useObjectVal = (0, _database.useObjectVal)(_firebase.db.ref('config')),
      _useObjectVal2 = _slicedToArray(_useObjectVal, 3),
      config = _useObjectVal2[0],
      loading = _useObjectVal2[1],
      error = _useObjectVal2[2];

  var _useLocalStorage = (0, _useLocalStorage3.useLocalStorage)('expo-app-remember-hide-discord-invite'),
      _useLocalStorage2 = _slicedToArray(_useLocalStorage, 2),
      hideDiscordInvite = _useLocalStorage2[0],
      setCloseDiscordInvite = _useLocalStorage2[1];

  var discordInviteLink = window.location.href.indexOf('live') >= 0 ? config && config.discordFullAccessInvite : config && config.discordReadOnlyInvite;
  return /*#__PURE__*/_react.default.createElement(Container, null, config && config.showTabNav && showTabNav && /*#__PURE__*/_react.default.createElement(Tabs, {
    as: "ul"
  }, !chatDisabled && /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement(_reactRouterDom.NavLink, {
    to: "".concat(url),
    exact: !chatDisabled,
    activeClassName: "selected"
  }, "Chat")), /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement(_reactRouterDom.NavLink, {
    to: chatDisabled ? "".concat(url) : "".concat(url, "/about"),
    activeClassName: "selected",
    exact: chatDisabled
  }, "About")), perks && /*#__PURE__*/_react.default.createElement("li", null, /*#__PURE__*/_react.default.createElement(_reactRouterDom.NavLink, {
    to: "".concat(url, "/perks"),
    activeClassName: "selected"
  }, "Perks & Resources"))), /*#__PURE__*/_react.default.createElement(_reactRouterDom.Switch, null, !chatDisabled && /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
    exact: !chatDisabled,
    path: path
  }, /*#__PURE__*/_react.default.createElement(PartnerInfo, null, /*#__PURE__*/_react.default.createElement(ImageContainer, null, /*#__PURE__*/_react.default.createElement("img", {
    src: logo
  })), /*#__PURE__*/_react.default.createElement(Description, null, /*#__PURE__*/_react.default.createElement("p", null, description), aboutLink && aboutLink.link && aboutLink.text && /*#__PURE__*/_react.default.createElement("p", null, /*#__PURE__*/_react.default.createElement("a", {
    href: aboutLink.link,
    target: "_blank"
  }, aboutLink.text)))), /*#__PURE__*/_react.default.createElement(Chat, null, /*#__PURE__*/_react.default.createElement(DiscordOverlay, null, /*#__PURE__*/_react.default.createElement(DiscordIcon, null), /*#__PURE__*/_react.default.createElement(DiscordText, null, "Speak with company reps in chat below or visit our Discord server."), /*#__PURE__*/_react.default.createElement(DiscordLink, {
    as: "a",
    href: config && config.discordLink,
    target: "_blank"
  }, "Open Discord")), discordEmbedLink && /*#__PURE__*/_react.default.createElement(ChatIfrmae, {
    src: discordEmbedLink,
    frameborder: "0"
  }), !hideDiscordInvite && /*#__PURE__*/_react.default.createElement(DiscordLoginOverlay, null, /*#__PURE__*/_react.default.createElement(DiscordLoginOverlayText, null, /*#__PURE__*/_react.default.createElement("a", {
    href: discordInviteLink,
    target: "_blank"
  }, "Accept discord invitation to ask questions")), /*#__PURE__*/_react.default.createElement(DiscordLoginOverlayClose, {
    onClick: function onClick() {
      setCloseDiscordInvite('true');
    }
  }, "Close")))), /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
    path: chatDisabled ? path : "".concat(path, "/about"),
    exact: chatDisabled
  }, /*#__PURE__*/_react.default.createElement(PartnerInfo, null, /*#__PURE__*/_react.default.createElement(ImageContainer, {
    bigger: true
  }, /*#__PURE__*/_react.default.createElement("img", {
    src: logo
  })), /*#__PURE__*/_react.default.createElement(Description, {
    extended: true
  }, descriptionExtended ? /*#__PURE__*/_react.default.createElement("div", {
    dangerouslySetInnerHTML: {
      __html: descriptionExtended
    }
  }) : /*#__PURE__*/_react.default.createElement("p", null, description)))), perks && /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
    path: "".concat(path, "/perks")
  }, /*#__PURE__*/_react.default.createElement(PartnerInfo, null, /*#__PURE__*/_react.default.createElement(Description, {
    extended: true
  }, /*#__PURE__*/_react.default.createElement("div", {
    dangerouslySetInnerHTML: {
      __html: perks
    }
  }))))));
}